import { ref } from "vue";

export function useServiceWorkerRegistration() {
  const showAppLoader = ref(false);

  return {
    showAppLoader,
    refreshSW() {},
  };
}
